export default "__VITE_ASSET__CPDSE2xl__"